import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';

import type { PlacesAutocompleteResult } from '@/sections/address/components/AddressForm/Autocomplete/interfaces';

export interface PlaceData {
  possibleRegion: string;
  possibleCommune: string;
  place: PlacesAutocompleteResult;
}

interface PlaceDataContextType {
  placeData: PlaceData | null;
  setPlaceData: (data: PlaceData | null) => void;
}

const PlaceDataContext = createContext<PlaceDataContextType | undefined>(
  undefined
);

export const PlaceDataProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [placeData, setPlaceData] = useState<PlaceData | null>(null);

  return (
    <PlaceDataContext.Provider value={{ placeData, setPlaceData }}>
      {children}
    </PlaceDataContext.Provider>
  );
};

export const usePlaceData = () => {
  const context = useContext(PlaceDataContext);
  if (context === undefined) {
    throw new Error('usePlaceData must be used within a PlaceDataProvider');
  }
  return context;
};
